@if (!!toolbarMenuOpen) {
  <div class="modal custom--modal modal--small" @fade>
    <header class="modal__header">
      <p class="t-data t-bold" data-test-id="mobileMenuToolbarLabel">
        {{ navigationService.config.toolbar.label }}
      </p>
    </header>
    <main class="modal__body">
      @for (
        route of navigationService.config.toolbar.routes;
        track route;
        let i = $index
      ) {
        <div
          class="mobile-menu__option"
          [ngClass]="{ 'is-active': i === navigationService.activeRouteIdx }"
          (click)="
            navigationService.navigateSelected(route, i);
            toolbarMenuOpen = false
          "
        >
          <i class="icon icon--medium" data-test-id="mobileMenuRouteIcon">
            {{
              i === navigationService.activeRouteIdx
                ? route.icon + '_active'
                : route.icon
            }}
          </i>
          <p class="t-data" data-test-id="mobileRouteLabel">
            {{ route.label }}
          </p>
          <div class="u-fillRemaining u-flex u-justifyEnd">
            <i
              class="icon icon--medium icon--pointer"
              data-test-id="mobileMenuRadioIcon"
              >{{
                i === navigationService.activeRouteIdx
                  ? 'radio_active'
                  : 'radio'
              }}</i
            >
          </div>
        </div>
      }
    </main>
  </div>
}

@if (!!navigationService.mobileMenuOpen) {
  <section class="modal__mask" @fade></section>
}

@if (!!navigationService.mobileMenuOpen) {
  <menu
    class="mobile-menu"
    [ngClass]="{
      'mobile-menu--alt':
        !!navigationService.config.navAlt || !!navigationService.config.toolbar,
      'is-toolbar-open': !!toolbarMenuOpen,
    }"
    @slideLeft
  >
    <header class="mobile-menu__header">
      <zip-button
        [config]="{
          level: 'text',
          icon: 'close',
          content: 'Menu',
        }"
        (zipButtonClicked)="navigationService.toggleMobileMenu()"
        data-test-id="mobileMenuCloseButton"
      >
      </zip-button>
    </header>
    <main class="mobile-menu__body">
      @if (isMobileToolbarDisplay()) {
        <section class="mobile-menu__toolbar">
          <div class="mobile-menu__item" data-test-id="mobileMenuItem">
            @if (navigationService.activeRoute?.label) {
              <p
                data-test-id="mobileMenuActiveRouteLabel"
                class="t-data t-bold"
                [innerHTML]="navigationService.activeRoute.label"
              ></p>
            }
            <div class="u-fillRemaining u-flex u-justifyEnd">
              <icon
                name="edit"
                [config]="{ type: 'pointer' }"
                (click)="toolbarMenuOpen = true"
                data-test-id="mobileMenuEditIcon"
              ></icon>
            </div>
          </div>
        </section>
      }
      @if (mobileMenuSections) {
        @for (section of mobileMenuSections; track section; let i = $index) {
          <section class="mobile-menu__section">
            @for (link of section; track link) {
              @if (isLoginOrRegisterMenuVisibile(link)) {
                <div
                  class="mobile-menu__item"
                  [ngClass]="{
                    'is-open': !!link.items && !!link.open,
                    'is-active': navigationService.isActiveRoute(link.route),
                  }"
                  (click)="linkClick($event, link)"
                >
                  @if (!!link.route || !!link.onClick) {
                    <p
                      class="t-data"
                      [ngClass]="
                        !!link.icon &&
                        'u-flex u-justifyBetween u-alignCenter u-maxX'
                      "
                      data-test-id="'mobileMenuLinkLabel' + i"
                    >
                      {{ link.label }}
                      @if (link.icon || link.type === 'languageSelector') {
                        <span
                          class="u-flex u-justifyBetween u-alignCenter"
                          data-test-id="'mobileMenuLinkIconContainer' + i"
                        >
                          @if (link.type === 'languageSelector' && !!language) {
                            <span
                              [innerHTML]="language.label"
                              data-test-id="'mobileMenuLanguageLabel' + i"
                            ></span>
                          }
                          <icon
                            [name]="link.icon"
                            [config]="{ type: 'pointer' }"
                            data-test-id="'mobileMenulinkIcon' + i"
                          ></icon>
                        </span>
                      }
                    </p>
                  }
                  @if (!!link.link) {
                    <a
                      class="t-data"
                      [href]="link.link"
                      target="_blank"
                      [innerHTML]="link.label"
                      data-test-id="'mobileMenuLinkAnchor' + i"
                    ></a>
                  }
                  @if (!!link.items) {
                    <div class="u-flex u-fillRemaining">
                      <div class="u-fillRemaining">
                        <p
                          class="t-data"
                          [innerHTML]="link.label"
                          data-test-id="'mobileMenuLinkLabel' + i"
                        ></p>
                      </div>
                      <icon
                        [ngClass]="{ 'icon--rotate180': !!link.open }"
                        name="chevron_down"
                        [config]="{ type: 'pointer' }"
                        data-test-id="'mobileMenuChevronIcon' + i"
                      ></icon>
                    </div>
                  }
                  @if (!!link.items && !!link.open) {
                    <div @accordion class="mobile-menu__subitems">
                      @for (item of link.items; track item; let i = $index) {
                        <div class="mobile-menu__subitem">
                          <a
                            class="t-data"
                            [routerLink]="item.route"
                            (click)="itemClick(item)"
                            [innerHTML]="item.label"
                            data-test-id="'mobileMenuSubitemLink' + i"
                          ></a>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            }
          </section>
        }
        @if (!!navigationService.config.menu.footer) {
          <footer class="mobile-menu__footer">
            <div class="mobile-menu__item">
              <div class="mobile-menu__item__icon">
                <i
                  class="icon icon--medium"
                  data-test-id="mobileMenuFooterIcon"
                  >{{ navigationService.config.menu.footer.icon }}</i
                >
              </div>
              <p class="t-data" data-test-id="mobileMenuFooterLabel">
                {{ navigationService.config.menu.footer.label }}
              </p>
            </div>
          </footer>
        }
      }
    </main>
  </menu>
}

@if (!!navigationService.config.toolbar?.languageSelector?.modalConfig) {
  <modal
    class="language-selector-modal"
    [config]="navigationService.config.toolbar?.languageSelector?.modalConfig"
    [condition]="showLangSelector"
    (cancel)="callback('toggleLang')"
    data-test-id="mobileMenuLanguageSelectorModal"
  >
    <div body>
      <language-selector
        class="mobile-menu__lang"
        [config]="navigationService.config.toolbar?.languageSelector?.languages"
        mode="radio"
        data-test-id="mobileMenuLanguageSelector"
      ></language-selector>
    </div>
  </modal>
}
